import { MeterBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { gameConstants } from "../Constants/gameConstants";
import { Model as platformModel } from "@quest/platform-murka/dist";
import { IObject, Linear, round, toInt } from "@quest/base-core";
import { toLocaleMoney, toLocaleNum } from "@quest/murka-games-behavior-leopard/dist/Game/Utils/NumberFormatter";
import { ingenuity } from "@quest/base-core";

export class MeterGame extends MeterBehavior {
    private showCurrency: boolean;
    private noFormatting: boolean;
    private timeDuration: number;
    private onlyNumber: boolean;
    private tickUpValue: number;
    private callBackFun: () => void;
    private isRestartTickUp: boolean;


    /*
    Ovveride to startTick
    */
    startTick(value: number, showCurrency: boolean, noFormatting: boolean, duration: number, onlyNumber: boolean, callback: () => void) {
        let updateCallBack: (arg: IObject) => {};

        if (this.ticking) {
            return value;
        }
        this.tickUpRunning = true;
        this.endValue = value;
        this.showCurrency = showCurrency;
        this.noFormatting = noFormatting;
        this.timeDuration = duration;
        this.onlyNumber = onlyNumber;
        this.tickUpValue = this.endValue;
        this.callback = callback;
        this.callBackFun = this.callback;
        if (this.value >= value) {
            this.ticking = false;
            this.stopTick(showCurrency, noFormatting, onlyNumber);
            return value;
        }
        this.ticking = true;
        this.onTickupStart.dispatch();
        this.duration = duration * 1000;
        let divider;
        this.tickupAnim = this.game.add.tween(this).to({
            value
        }, this.duration, Linear.None, true);
        this.tickupAnim.onComplete.addOnce(() => {
            this.stopTick(showCurrency, noFormatting, onlyNumber);
        }, this);
        this.tickupAnim.onUpdateCallback(() => {
            if (this.value < value) {
                divider = (value - this.value) / Math.round((this.game.time.fps || this.game.time.desiredFps) * duration);
                if (!isFinite(divider) || isNaN(divider)) {
                    divider = 0.1;
                }
                this.value += divider;
                (this.value > value) && (this.value = value);
                if (onlyNumber) {
                    if (showCurrency) {
                        this.setCurrencyFormattedValue(`${round(this.value, 2)}`);
                    }
                    else if (noFormatting) {
                        this.setValue(toInt(`${this.value}`));
                    }
                    else {
                        this.setFormattedValue(`${round(this.value, 2)}`);
                    }
                }
                else {
                    if (showCurrency) {
                        this.setCurrencyFormattedString(this.json.text, `${round(this.value, 2)}`);
                    }
                    else {
                        this.setFormattedString(this.json.text, `${round(this.value, 2)}`);
                    }
                }
                updateCallBack && updateCallBack(this);
            }
            else {
                this.stopTick(showCurrency, noFormatting, onlyNumber);
            }
        }, this);
    }

    /*
    Ovveride to stop calling callback
    */
    stopTick(showCurrency?: boolean, noFormatting?: boolean, onlyNumber?: boolean, noCallback?: boolean): void {
        this.tickUpRunning = false;
        if (this.ticking) {
            if (typeof this.tickupAnim === "undefined" || this.tickupAnim === null) {
                return;
            }
            this.ticking = false;
            this.tickupAnim.stop(false);
            this.tickupAnim.onUpdateCallback(null, this);
            if (onlyNumber) {
                if (showCurrency) {
                    this.setCurrencyFormattedValue(`${this.endValue}`);
                }
                else if (noFormatting) {
                    this.setValue(toInt(`${this.endValue}`));
                }
                else {
                    this.setFormattedValue(`${this.endValue}`);
                }
            }
            else {
                if (showCurrency) {
                    this.setCurrencyFormattedString(this.json.text, `${this.endValue}`);
                }
                else {
                    this.setFormattedString(this.json.text, `${this.endValue}`);
                }
            }
            this.endValue = 0;
            this.duration = 0;
            this.game.tweens.remove(this.tickupAnim);
            this.tickupAnim = null;
            this.onTickupComplete.dispatch();
            if (!noCallback) {
                this.callback && this.callback();
            }
            this.tickupCompleteCallBack && this.tickupCompleteCallBack();
            this.tickupCompleteCallBack = null;
        }
    }

    /**
     * Method Overrided to add DEC currency value.
     * @param value 
     */
    public setCurrencyFormattedValue(value: string): void {
        this.value = isNaN(Number(value)) ? Number(value.match(/[0-9]+/g).join(".")) : Number(value);

        const removeAfterDecimalValueArray: string[] = gameConstants.REMOVE_VALUE_AFTER_DECIMAL_PALACE_ON_CURRENCY;
        if (removeAfterDecimalValueArray.indexOf((ingenuity.parserModel as platformModel).getCurrencyId()) > -1) {
            this.formatedValue = toLocaleNum(this.value, 0);
            this.currencyFormattedValue = toLocaleMoney(this.value, 0);
        } else {
            this.formatedValue = toLocaleNum(this.value);
            this.currencyFormattedValue = toLocaleMoney(this.value);
        }
        this.setText(this.currencyFormattedValue, true);
    }

    /**
     * Method Overrided to pause tickup.
     */
    public pauseTickUp(): void {
        if (this.tickUpRunning) {
            this.stopTick(this.showCurrency, this.noFormatting, this.onlyNumber, true);
            this.isRestartTickUp = true;
        }
    }

    /**
     * Method Overrided to resume tickup.
     */
    public resumeTickUp(): void {
        if (this.isRestartTickUp) {
            this.setValue(0);
            this.startTick(this.tickUpValue, this.showCurrency, this.noFormatting, this.timeDuration, this.onlyNumber, this.callBackFun);
            this.isRestartTickUp = false;
        }
    }
}